import { IntroductionModalTranslations } from "./types";

export const deTranslations: IntroductionModalTranslations = {
    heading:"Einführung",
    paragraphs: [
        "Willkommen zu Ihrem Dienst in der Notaufnahme. Sie sind heute für die Triage und das initiale Management der Patienten und Patientinnen zuständig. Ihr Dienst startet um 9:00 Uhr und endet um 17:00 Uhr.",
        "Sie können den zeitlichen Verlauf Ihres Dienstes jederzeit in der Uhr in der Menüleiste verfolgen. Die Zeit läuft nur, wenn Sie Untersuchungen und Behandlungen durchführen.",
        "Versuchen Sie innerhalb Ihres Dienstes möglichst viele Patienten und Patientinnen sicher zu diagnostizieren, zu behandeln, sich dafür von entsprechenden Fachrichtungen im Haus weitere Informationen einzuholen und sie abschließend zu verlegen oder zu entlassen."
    ]
}